export default  {
    namespaced: true,
    state: () => ({
        email: null,
        nome: null,
        cognome: null,
        telefono: null,
        iban:null,
        firma:null
    }),
    actions :  {
        commitNome: (context,nome)=>{
            context.commit('setNome',nome);
        },
        commitCognome: (context,cognome)=>{
            context.commit('setCognome',cognome);
        },
        commitEmail: (context,email)=>{
            context.commit('setEmail',email);
        },
        commitTelefono: (context,telefono)=>{
            context.commit('setTelefono',telefono);
        },
        commitFirma: (context,firma)=>{
            context.commit('setFirma',firma);
        },
        commitIban: (context,iban)=>{
            context.commit('setIban',iban);
        },

    },
    mutations: {
        setNome: (state,nome)=>{
            state.nome = nome;
        },
        setCognome: (state,cognome)=>{
            state.cognome = cognome;
        },
        setEmail: (state,email)=>{
            state.email = email;
        },
        setTelefono: (state,telefono)=>{
            state.telefono = telefono;
        },
        setFirma: (state,firma)=>{
            state.firma = firma;
        },
        setIban: (state,iban)=>{
            state.iban = iban;
        }
    },
    getters :{
        getNome: (state)=>{
            return state.nome;
        },
        getCognome: (state)=>{
            return state.cognome;
        },
        getEmail: (state)=>{
            return state.email;
        },
        getTelefono: (state)=>{
            return state.telefono;
        },
        getFirma: (state)=>{
            return state.firma;
        },
        getIban: (state)=>{
            return state.iban;
        }
    }
}



